// extracted by mini-css-extract-plugin
module.exports = {"nav_next":"nav_next-27Ys7","nav_prev":"nav_prev-18CoI"};